"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CeramicService = exports.NotAllowedNetworkError = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@ceramicnetwork/common");
const http_client_1 = (0, tslib_1.__importDefault)(require("@ceramicnetwork/http-client"));
const idx_1 = require("@ceramicstudio/idx");
const dids_1 = require("dids");
const connect_1 = require("@3id/connect");
const key_did_resolver_1 = (0, tslib_1.__importDefault)(require("key-did-resolver"));
const _3id_did_resolver_1 = (0, tslib_1.__importDefault)(require("@ceramicnetwork/3id-did-resolver"));
const rxjs_1 = require("rxjs");
class NotAllowedNetworkError extends Error {
    constructor(network) {
        super(`Network ${network} is not supported`);
    }
}
exports.NotAllowedNetworkError = NotAllowedNetworkError;
function ceramicEndpoint(network) {
    switch (network) {
        case common_1.Networks.MAINNET:
            return "https://gateway.ceramic.network";
        case common_1.Networks.TESTNET_CLAY:
            return "https://gateway-clay.ceramic.network";
        case common_1.Networks.DEV_UNSTABLE:
            return "https://gateway-dev.ceramic.network";
        default:
            throw new NotAllowedNetworkError(network);
    }
}
class CeramicService {
    constructor(network, endpoint, connect) {
        this.network = network;
        const effectiveEndpoint = endpoint || ceramicEndpoint(network);
        this.client = new http_client_1.default(effectiveEndpoint);
        this.idx = new idx_1.IDX({ ceramic: this.client });
        this._isAuthenticated$ = new rxjs_1.BehaviorSubject(false);
        this.connect = connect;
    }
    get isAuthenticated$() {
        return this._isAuthenticated$.asObservable();
    }
    get isAuthenticated() {
        return this._isAuthenticated$.value;
    }
    get did() {
        if (this.client.did) {
            return this.client.did;
        }
        else {
            throw new Error(`Not authenticated`);
        }
    }
    async authenticate(authProvider) {
        const provider = authProvider || (await this.connect());
        const threeIdConnect = new connect_1.ThreeIdConnect(this.network);
        await threeIdConnect.connect(provider);
        const didProvider = threeIdConnect.getDidProvider();
        const did = new dids_1.DID({
            provider: didProvider,
            resolver: {
                ...key_did_resolver_1.default.getResolver(),
                ..._3id_did_resolver_1.default.getResolver(this.client),
            },
        });
        await did.authenticate();
        this.client.did = did;
        this._isAuthenticated$.next(true);
        return did;
    }
}
exports.CeramicService = CeramicService;
//# sourceMappingURL=ceramic-service.js.map